import { ContentControlledEditingDirective } from '../editing-directive';
import { ContentControlledKeyframe } from '../keyframe';
import ContentControlStudioOperation from "./content-control-studio-operation";

export default class ContentControlStudioAddKeyframeToEventOperation extends ContentControlStudioOperation {
  constructor(
    public eventId: number,
    public events: Array<ContentControlledEditingDirective>,
    public keyframe: ContentControlledKeyframe,
    callback?,
  ) {
    super(
      () => {
        const event = events.find((x) => x.id == eventId);
        if (event) {
          if (
            event.keyframes.findIndex((x) => x.timeInMs == keyframe.timeInMs) ==
            -1
          ) {
            event.keyframes.push(keyframe);
            event.sortKeyframes();
          }
        }
      },
      () => {
        const event = events.find((x) => x.id == eventId);
        if (event) {
          const index = event.keyframes.findIndex(
            (x) => x.timeInMs == keyframe.timeInMs,
          );
          if (index) {
            event.keyframes.splice(index, 1);
          }
        }
      },
      callback,
    );
  }
}
